import type { ReactNode } from 'react';

import styles from './Screen.module.css';

/**
 * Route-level semantic and spacing wrapper. App owns route animation so there
 * is exactly one presence lifecycle regardless of which page is mounted.
 */
export function Screen({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <main className={styles.screen} aria-label={title}>
      {children}
    </main>
  );
}
